import type { MaterialInfo, PartDefinition } from "@rogue/rackbuilder"
import { FMLBuilder } from "../fmlBuilder"
import { createFMLPulleysBase } from "../standard/fmlParts"
import {
  createTwinFMLSideMeshes,
  createTwinFMLFrontSystem,
  createTwinFMLTopRailPulley,
  createTwinFMLBottomRailPulley,
  createTwinFMLBackPost,
} from "./twinFMLParts"

// TwinFMLBuilder — Assembles FML-6-Twin and FML-HR-Twin; half rack uses standard pulleys, twin weight stack and rail pulleys are full-rack-only
export class TwinFMLBuilder extends FMLBuilder {

  // MARK: Side Meshes
  protected buildFMLSideMeshes(
    materials: MaterialInfo,
    left: boolean,
    isHalfRack: boolean
  ): PartDefinition[] {
    // Half rack: twin uses standard pulleys (not twin weight stack)
    if (isHalfRack) {
      return [createFMLPulleysBase(materials, left)]
    }

    // Full rack: twin weight stack + optional twin side shrouds
    return createTwinFMLSideMeshes(this.createContext(materials), left)
  }

  // MARK: Front System (full rack only)
  protected buildFMLFrontSystem(
    materials: MaterialInfo,
    left: boolean,
    depth: string
  ): PartDefinition {
    return createTwinFMLFrontSystem({ ...this.createContext(materials), depth }, left)
  }

  // MARK: Extra Front Meshes (twin rail pulleys — full rack only)
  protected buildFMLExtraFrontMeshes(
    materials: MaterialInfo,
    left: boolean,
    depth: string
  ): PartDefinition[] {
    const context = { ...this.createContext(materials), depth }

    return [
      createTwinFMLTopRailPulley(context, left),
      createTwinFMLBottomRailPulley(context, left),
    ]
  }

  // MARK: Back Stabilizer Slots
  protected buildFMLBackStabilizerSlots(
    materials: MaterialInfo,
    left: boolean
  ): PartDefinition[] {
    if (!left) return []

    return [
      createTwinFMLBackPost(this.createContext(materials), this.buildFMLPullup()),
      this.buildFMLLowRow(materials),
    ]
  }
}
